export default function (
  country:
    | string
    | { active?: boolean; code?: string; id?: string; name?: string }
): string {
  if (typeof country === "string") {
    return country !== "US" ? (country ? "Province" : "State") : "State";
  }
  return country.id !== "US" ? (country.id ? "Province" : "State") : "State";
}
